import { AnimatePresence, motion } from 'framer-motion'
import { FormEvent, useContext, useRef } from 'react'
import { HeaderContext } from '../header/header-provider.client'
import styles from '../../assets/scss/components/collections/filter-drawer.module.scss'
import { Image, Link, useUrl, useNavigate } from '@shopify/hydrogen'
import { FilterAccordions } from './filter-accordions.client'
import { useI18n } from '../i18n.client'
import { EnhancedMenuItem } from '../../lib/menus'

export const FilterDrawer: React.FC<{
  filterTagsColour: string[]
  filterTagsMaterial: string[]
  collectionsMenu?: EnhancedMenuItem
  showProductTypeFilter?: boolean
}> = ({ collectionsMenu, filterTagsColour, filterTagsMaterial, showProductTypeFilter }) => {
  const [i18n] = useI18n()
  const { isFilterDrawerOpen, setIsFilterDrawerOpen } = useContext(HeaderContext)
  const form = useRef<HTMLFormElement>(null)
  const { pathname } = useUrl()
  const navigate = useNavigate()

  let resetUrl = '/collections/all'
  const languagePath = pathname.match(/(\/.+?)\//)
  if (languagePath) {
    resetUrl = pathname.replace(languagePath[1], '')
  }

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault()

    if (form.current) {
      const formData = new FormData(form.current)
      const query =
        `?${formData.get('sortBy')}` +
        `&productTypes=${formData.getAll('productTypes').join()}` +
        `&tags=${formData.getAll('tags').join()}`
      const basePath = languagePath ? pathname.replace(languagePath[1], '') : pathname
      navigate(basePath + query)
      setIsFilterDrawerOpen(false)
    }
  }

  return (
    <>
      <AnimatePresence>
        {isFilterDrawerOpen && (
          <motion.div
            animate={{ opacity: 1 }}
            className={styles.overlay}
            exit={{ opacity: 0, transition: { ease: [1, 0, 1, 1] } }}
            id="overlay"
            initial={{ opacity: 0 }}
            onClick={() => setIsFilterDrawerOpen(false)}
            transition={{ ease: [0, 0, 0, 1] }}
          />
        )}
      </AnimatePresence>
      <AnimatePresence>
        {isFilterDrawerOpen && (
          <motion.div
            animate={{ translateX: 0 }}
            className={styles.filterDrawer}
            exit={{ translateX: '-100%', transition: { ease: [1, 0, 1, 1] } }}
            id="filter-drawer"
            initial={{ translateX: '-100%' }}
            transition={{ ease: [0, 0, 0, 1] }}>
            <form className={styles.filterForm} onSubmit={handleSubmit} ref={form}>
              <div className={styles.header}>
                <h1 className={styles.title}>{i18n.translate('filters')}</h1>
                <div className={styles.close} onClick={() => setIsFilterDrawerOpen(false)}>
                  <Image alt={i18n.translate('close')} height={12} src="/cross.svg" width={12} />
                </div>
              </div>
              <FilterAccordions
                collectionsMenu={collectionsMenu}
                filterTagsColour={filterTagsColour}
                filterTagsMaterial={filterTagsMaterial}
                showProductTypeFilter={showProductTypeFilter}
              />
              <div className={styles.filterActions}>
                <Link to={resetUrl} onClick={() => setIsFilterDrawerOpen(false)}>
                  {i18n.translate('clear-all')}
                </Link>
                <input className={styles.button} type="submit" value={i18n.translate('apply-filters')} />
              </div>
            </form>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  )
}
